var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs, _clipPath, _path0, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2500,
    height: 636,
    viewBox: "0.851 0 1022.301 260.001"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ed1b2d",
    d: "M983.85 246.414h4.493l2.684 9.74 2.917-9.74h4.349v13.301h-2.721v-11.412l-3.48 11.412h-2.28l-3.423-11.412v11.412h-2.539zm-8.641 2.214h-4.675v-2.214h12.121v2.214h-4.632v11.087h-2.814z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009a4e",
    d: "M1023.151 0h-841.53c-29.417 0-44.397.304-60.773 2.316-36.87 4.27-69.428 20.175-89.365 43.666C11.524 69.783.851 98.823.851 129.883c0 35.234 13.916 68.284 39.28 93.026 18.895 18.453 43.203 29.655 74.248 34.294 20.733 3.105 41.466 2.91 59.832 2.686l12.758-.102h766.704z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M949.2 254.041H186.969c-50.562 0-103.18 3.3-142.757-35.293-23.236-22.737-37.529-54.086-37.529-88.865 0-30.387 10.956-58.725 29.055-80.204 20.754-24.496 53.428-37.797 85.804-41.625 16.659-2.055 32.181-2.301 60.078-2.301h833.903z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed1b2d",
    d: "M812.037 96.348c-4.074 0-6.824 1.788-9.683 4.603-9.747 9.574-20.964 38.738-26.493 61.293-2.54 10.819-3.748 16.898-3.748 23.266 0 6.029 2.75 9.423 7.475 9.423 3.706 0 7.707-2.576 10.508-5.558 5.08-5.262 8.583-12.946 12.57-22.477 9.502-22.484 16.297-51.75 16.297-61.331 0-4.66-1.433-9.219-6.926-9.219m34.476 62.3c-11.962 33.433-31.66 60.477-70.405 60.477-26.826 0-42.103-13.02-42.103-40.619 0-12.201 3.032-25.205 6.868-36.733 10.941-32.116 34.714-69.696 72.684-69.696 28.404 0 42.139 14.35 42.139 42.414-.001 13.532-4.538 31.37-9.183 44.157m-437.714 20.661c0 8.67 4.103 15.573 13.525 15.573 3.561 0 6.896 0 10.479-.774l12.52-45.721c-17.369 2.092-36.524 10.514-36.524 30.922m79.892-52.603-23.707 86.058c-16.601 4.32-33.716 6.838-51.098 6.838-21.913 0-43.63-10.674-43.63-35.444 0-43.116 46.452-55.375 81.181-58.674 1.809-5.637 3.561-11.492 3.561-17.375 0-9.661-8.424-12.013-16.594-12.013-11.448 0-27.051 3.104-37.985 6.636l6.115-23.498c11.716-5.087 29.583-7.359 42.378-7.359 20.913 0 43.383 6.665 43.383 31.639 0 7.879-1.52 15.565-3.604 23.192M765.94 75.883c-5.761-3.119-15.573-3.807-23.584-3.807-16.029 0-34.96 2.844-49.455 10.276l-37.037 133.45h37.298l31.775-116.14c5.558-2.004 11.064-2.793 16.927-2.793 4.819 0 7.525.239 9.689.354zm-378.75-6.477c0-25.285-17.1-34.208-40.076-34.208-23.215 0-42.855 10.681-57.646 28.303-20.711 24.742-37.833 77.135-37.833 108.991 0 33.439 13.807 49.549 47.725 49.549 47.292 0 58.732-38.332 69.725-76.361l-40.836 7.679c-3.3 10.688-11.492 41.603-25.82 41.603-8.655 0-10.442-8.133-10.442-15.275 0-21.457 12.787-62.315 20.443-82.715 4.082-10.747 14.553-35.518 28.831-35.518 3.278 0 5.572 1.766 6.571 3.466 1.31 1.983 1.679 4.284 1.679 7.128 0 1.129-.282 4.486-.818 6.903-.991 5.066-8.438 32.015-8.438 32.015l39.288-6.86c3.031-10.551 7.647-23.787 7.647-34.7m205.093 6.513c-9.473-2.786-19.879-4.045-29.641-4.045-28.802 0-59.326 15.53-59.587 47.972-.253 29.365 35.431 39.273 35.25 55.91-.159 13.539-12.165 18.641-23.881 18.641-9.466 0-19.524-1.28-28.679-3.835l-6.506 22.455c11.977 3.843 26.537 5.602 38.983 5.602 29.135 0 56.062-16.579 56.373-48.218.297-31.176-33.36-38.021-33.245-55.91.116-13.843 13.96-17.86 25.48-17.86 6.071 0 12.715.478 18.858 1.816zm87.976.818H652.97l10.638-39.367-39.266 6.426-8.626 32.941h-13.569l-6.129 21.71h13.554s-20.964 76.274-22.477 82.621c-1.013 4.124-2.048 9.212-2.048 13.329 0 10.204 6.665 17.586 15.298 19.901 3.271 1.027 8.923 1.505 15.371 1.505h27.058l6.078-21.934h-13.749c-6.115 0-11.745-.536-11.745-7.672 0-1.779.514-3.85.984-6.354.76-3.09 22.491-81.397 22.491-81.397h27.246zm214.457 98.751c-.825 3.582-1.317 6.672-1.317 9.183 0 7.649 5.876 9.198 12.266 9.198h12.795l-5.152 21.934h-25.51c-7.981 0-14.32-.789-18.156-2.279-8.647-3.59-14.264-11.253-14.264-22.737 0-5.124 1.021-10.436 2.272-15.79 1.549-6.65 35.966-130.187 35.966-130.187l39.107-7.439c0-.001-36.755 132.465-38.007 138.117"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9b29d",
    d: "M99.261 136.975a2.39 2.39 0 0 1-2.402-2.402c0-1.346 1.035-2.425 2.402-2.425h6.521c1.273 0 2.424 1.079 2.424 2.425 0 1.303-1.151 2.402-2.424 2.402zm-7.157-7.997a1.66 1.66 0 0 1-1.657-1.643c0-.948.746-1.665 1.657-1.665h4.132c.883 0 1.628.716 1.628 1.665a1.64 1.64 0 0 1-1.628 1.643zm-.253 14.611H87.82c-.948 0-1.628-.782-1.628-1.687s.73-1.65 1.628-1.65h4.031c.912 0 1.672.746 1.672 1.65s-.724 1.687-1.672 1.687m-8.156-7.396h-4.016c-.919 0-1.643-.775-1.643-1.65 0-.934.724-1.686 1.643-1.686h4.016c.956 0 1.672.752 1.672 1.686 0 .875-.717 1.65-1.672 1.65m-7.736-7.215h-4.06a1.647 1.647 0 0 1-1.665-1.643c0-.948.724-1.665 1.665-1.665h4.06c.926 0 1.693.716 1.693 1.665 0 .897-.767 1.643-1.693 1.643m-4.32 14.611h-4.052c-.912 0-1.729-.782-1.729-1.687s.817-1.65 1.729-1.65h4.052c.912 0 1.628.746 1.628 1.65s-.716 1.687-1.628 1.687m4.61-32.55h4.031c.926 0 1.701.745 1.701 1.679 0 .919-.731 1.679-1.701 1.679h-4.031c-.955 0-1.679-.76-1.679-1.679 0-.934.723-1.679 1.679-1.679m7.822 7.186h4.089c.912 0 1.693.745 1.693 1.679 0 .941-.782 1.665-1.693 1.665h-4.089c-.941 0-1.715-.724-1.715-1.665 0-.934.774-1.679 1.715-1.679m12.411-7.186h4.053c.912 0 1.679.745 1.679 1.679 0 .919-.767 1.679-1.679 1.679h-4.053c-.94 0-1.729-.76-1.729-1.679-.001-.934.789-1.679 1.729-1.679m13.554 6.433c1.361 0 2.432 1.1 2.432 2.41 0 1.324-1.071 2.374-2.432 2.374h-6.505c-1.317 0-2.46-1.049-2.46-2.374 0-1.31 1.143-2.41 2.46-2.41z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed1b2d",
    d: "M84.071 121.568h4.089c.912 0 1.693-.724 1.693-1.665 0-.934-.782-1.679-1.693-1.679h-4.089c-.941 0-1.715.745-1.715 1.679 0 .941.774 1.665 1.715 1.665m12.411-7.172h4.053c.912 0 1.679-.76 1.679-1.679 0-.934-.767-1.679-1.679-1.679h-4.053c-.941 0-1.729.745-1.729 1.679-.001.919.788 1.679 1.729 1.679m29.402-5.275h-6.795c-2.026 0-3.662 1.563-3.662 3.597a3.654 3.654 0 0 0 3.662 3.647h5.051l2.186-7.244zm-24.814 10.761c0 1.324 1.143 2.374 2.46 2.374h6.506c1.36 0 2.432-1.049 2.432-2.374 0-1.31-1.071-2.41-2.432-2.41h-6.506c-1.317 0-2.46 1.1-2.46 2.41m5.688 21.948c0 1.998 1.665 3.626 3.626 3.626h5.181l2.135-7.251h-7.316c-1.962 0-3.626 1.6-3.626 3.625"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed1b2f",
    d: "M119.806 131.004h.007l.022-.035h-.022z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed1b2d",
    d: "M111.259 127.27c0 2.019 1.636 3.734 3.611 3.734h4.936l.007-.035h.022l2.2-7.411h-7.164c-1.976 0-3.612 1.715-3.612 3.712m-19.408 12.982H87.82c-.897 0-1.628.746-1.628 1.65s.68 1.687 1.628 1.687h4.031c.948 0 1.672-.782 1.672-1.687s-.761-1.65-1.672-1.65m6.013-12.917c0-.948-.746-1.665-1.628-1.665h-4.132c-.912 0-1.657.716-1.657 1.665 0 .897.745 1.643 1.657 1.643h4.132c.905 0 1.628-.746 1.628-1.643m10.341 7.237c0-1.346-1.15-2.425-2.424-2.425H99.26c-1.368 0-2.402 1.079-2.402 2.425a2.39 2.39 0 0 0 2.402 2.402h6.521c1.274.001 2.424-1.099 2.424-2.402m-31.956-20.176h4.031c.97 0 1.701-.76 1.701-1.679 0-.934-.774-1.679-1.701-1.679h-4.031c-.955 0-1.679.745-1.679 1.679 0 .919.723 1.679 1.679 1.679"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed1b2d",
    d: "M179.276 115.011h-4.574a1.996 1.996 0 0 1-1.998-1.99c0-1.1.912-1.99 1.998-1.99h4.574c1.078 0 1.925.89 1.925 1.99 0 1.115-.847 1.99-1.925 1.99m-4.298 14.206h-4.588c-1.021 0-1.961-.818-1.961-1.947 0-1.114.941-1.997 1.961-1.997h4.588c1.114 0 2.004.883 2.004 1.997 0 1.129-.89 1.947-2.004 1.947m-4.285 14.372h-4.523a2.01 2.01 0 0 1-2.019-2.019c0-1.094.861-1.977 2.019-1.977h4.523c1.136 0 2.012.883 2.012 1.977a2.02 2.02 0 0 1-2.012 2.019m-9.27-7.027h-4.544a2.004 2.004 0 0 1-1.99-1.99c0-1.158.912-2.005 1.99-2.005h4.544c1.093 0 1.983.847 1.983 2.005 0 1.1-.89 1.99-1.983 1.99m-9.262-7.345h-4.552c-1.129 0-1.99-.818-1.99-1.947 0-1.114.861-1.997 1.99-1.997h4.552c1.085 0 1.997.883 1.997 1.997 0 1.129-.912 1.947-1.997 1.947m-4.306 14.372h-4.509c-1.122 0-2.041-.934-2.041-2.019 0-1.094.919-1.977 2.041-1.977h4.509c1.114 0 2.041.883 2.041 1.977 0 1.085-.927 2.019-2.041 2.019m-15.458-6.355c-1.542 0-2.779-1.193-2.779-2.662a2.777 2.777 0 0 1 2.779-2.771h7.417c1.491 0 2.75 1.252 2.75 2.771 0 1.469-1.259 2.662-2.75 2.662zm4.27-20.081h7.468c1.483 0 2.692 1.267 2.692 2.729 0 1.527-1.208 2.764-2.692 2.764h-7.468c-1.556 0-2.75-1.237-2.75-2.764a2.745 2.745 0 0 1 2.75-2.729m15.219-6.122h4.537c1.107 0 2.004.89 2.004 1.99 0 1.114-.897 1.99-2.004 1.99h-4.537a2 2 0 0 1-1.99-1.99c0-1.1.918-1.99 1.99-1.99m9.277 6.889h4.516a1.97 1.97 0 0 1 1.997 1.961c0 1.129-.861 2.033-1.997 2.033h-4.516c-1.085 0-1.99-.904-1.99-2.033 0-1.063.905-1.961 1.99-1.961m70.955-8.799h-99.72a3.73 3.73 0 0 1 2.714 3.597c0 2.012-1.592 3.647-3.597 3.647h-7.374l-2.164 7.193h5.355c1.976 0 3.611 1.701 3.611 3.756 0 1.983-1.636 3.655-3.611 3.655h-7.497l-.021.035h-.007l-2.106 7.201h5.102c1.983 0 3.604 1.6 3.604 3.625 0 1.787-1.31 3.293-3.09 3.669H233.14a104 104 0 0 0 1.151-15.407 103.4 103.4 0 0 0-2.173-20.971M71.639 140.252h-4.053c-.912 0-1.729.746-1.729 1.65s.818 1.687 1.729 1.687h4.053c.912 0 1.628-.782 1.628-1.687s-.717-1.65-1.628-1.65m12.056-7.395h-4.016c-.919 0-1.643.752-1.643 1.686 0 .875.724 1.65 1.643 1.65h4.016c.955 0 1.672-.775 1.672-1.65 0-.934-.717-1.686-1.672-1.686m-7.736-7.186h-4.06c-.941 0-1.665.716-1.665 1.665 0 .897.724 1.643 1.665 1.643h4.06c.926 0 1.693-.746 1.693-1.643 0-.949-.767-1.665-1.693-1.665"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__a",
    d: "M72.551 160.855c-6.607 0-12.208-.73-16.08-2.533-6.151-2.808-10.891-8.553-10.891-17.686 0-7.729 2.207-14.857 4.87-23.917l19.611-68.697c-24.908 18.743-41.01 48.514-41.01 82.07 0 56.677 45.931 102.608 102.608 102.608 45.974 0 84.864-30.206 97.933-71.845zm59.108-133.356c-12.439 0-24.366 2.207-35.401 6.252L79.44 93.641h148.177c-14.727-38.664-52.133-66.142-95.958-66.142"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo_svg__a",
    overflow: "visible"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#009a4e",
    d: "M234.202 130.143c0 56.685-45.938 102.629-102.623 102.629-56.67 0-102.601-45.944-102.601-102.629 0-56.648 45.931-102.615 102.601-102.615 56.685 0 102.623 45.967 102.623 102.615",
    clipPath: "url(#logo_svg__b)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__c",
    d: "M28.936 27.499h205.273v205.298H28.936z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo_svg__c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__d)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__e",
    d: "M29.051 27.499h200.541V232.7H29.051z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo_svg__e",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__f)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__g",
    d: "M232.045 151.014c-11.513 55.498-65.853 91.138-121.351 79.624-55.482-11.55-91.123-65.89-79.588-121.372 11.542-55.49 65.882-91.124 121.365-79.596 55.491 11.528 91.124 65.868 79.574 121.344"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo_svg__g",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__h)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__i",
    d: "M10.265 9.231h238.114V250.96H10.265z",
    transform: "rotate(-168.253 129.316 130.09)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__j"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo_svg__i",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m221.278 272.668-233.138-48.48L37.356-12.489l233.138 48.48z"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__k",
    d: "M116.39 28.798h106.639v78.121H116.39z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__l"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo_svg__k",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__l)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__m",
    d: "M116.39 28.802h106.639v78.119H116.39z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__n"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo_svg__m",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M118.047 29.409h103.889v76.082H118.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M119.719 30.02h101.117v74.034H119.719z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M121.376 30.623h98.36v72.002h-98.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M123.041 31.234h95.603v69.956h-95.603z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M124.705 31.838h92.838V99.76h-92.838z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M126.362 32.449h90.088v65.876h-90.088z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M128.026 33.053h87.324v63.836h-87.324z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M129.69 33.664h84.567V95.46H129.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M131.348 34.267h81.817v59.765h-81.817z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M133.005 34.878h79.061v57.718h-79.061z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M134.67 35.482h76.295V91.16H134.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M136.334 36.093h73.538v53.638h-73.538z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M137.998 36.703h70.774v51.6h-70.774z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M139.663 37.308h68.009v49.559h-68.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M141.32 37.91h65.259v47.528H141.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M142.984 38.522h62.502v45.48h-62.502z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M144.642 39.133h59.746v43.441h-59.746z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M146.306 39.736h56.996v41.401h-56.996z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M147.963 40.348h54.246v39.361h-54.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M149.628 40.951h51.481v37.323h-51.481z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M151.292 41.562h48.717v35.283h-48.717z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M152.949 42.166h45.967v33.251h-45.967z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M154.613 42.769h43.21v31.212h-43.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M156.278 43.38h40.445v29.172h-40.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M157.936 43.983h37.695v27.14h-37.695z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M159.6 44.587h34.938v25.1H159.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M161.264 45.19h32.174v23.069h-32.174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M162.921 45.793h29.424V66.83h-29.424z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M164.578 46.405h26.667v18.998h-26.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M166.243 47.008h23.909v16.958h-23.909z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M167.9 47.604h21.16v14.934H167.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M169.564 48.208h18.403v12.909h-18.403z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M171.222 48.804h15.653v10.885h-15.653z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M172.872 49.399h12.91v8.868h-12.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M174.529 49.979h10.167v6.868h-10.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M176.179 50.538h7.432v4.912h-7.432z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__l)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__o",
    d: "M153.919 38.399h49.672v36.979h-49.672z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__p",
    d: "M32.178 142.331H144.78v89.373H32.178z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__r"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo_svg__p",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M32.178 142.33H144.78v89.371H32.178z"
  })))))));
};
export default SvgLogo;